import React, { createContext, useContext, useEffect } from "react";
import { renewToken } from "../services/authConfig";

const RenovationTokenContext = createContext();

export const RenovationTokenContextProvider = ({ children }) => {


  useEffect(() => {
    const checkAndRenewToken = () => {
      const expirationTime = parseInt(localStorage.getItem("session_Exp_tok"), 10);

      if (!expirationTime || isNaN(expirationTime)) {
        renewToken();
        return;
      }

      const timeLeft = expirationTime - Date.now();

      if (timeLeft <= 0) {
        renewToken();
      } else if (timeLeft <= 25 * 60 * 1000) {
        renewToken();
      } else {
        setTimeout(() => renewToken(), timeLeft - 25 * 60 * 1000);
      }
    };

    checkAndRenewToken();
  }, []);

  return (
    <RenovationTokenContext.Provider value={{}}>
      {children}
    </RenovationTokenContext.Provider>
  );
};

export const useBackgroundTask = () => useContext(BackgroundTaskContext);
